var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "copy-summary-collapses" }, [
    _c(
      "div",
      { staticClass: "summary-header" },
      [
        _c("b-icon", {
          staticClass: "info-icon",
          attrs: { icon: "info-circle" },
        }),
        _c("span", { staticClass: "summary-title" }, [
          _vm._v(_vm._s(_vm.$t("resumodacopia"))),
        ]),
      ],
      1
    ),
    _c("p", { staticClass: "summary-description" }, [
      _vm._v(_vm._s(_vm.$t("visualizacaorapida"))),
    ]),
    _c(
      "div",
      { staticClass: "collapsible-sections" },
      [
        _c("CopyCategoryCollapse", {
          attrs: {
            variant: "created",
            "header-text": _vm.getCreatedHeaderText(),
            items: _vm.createdItems,
            show: _vm.showCreated,
          },
          on: { toggle: _vm.toggleCreated },
          scopedSlots: _vm._u([
            {
              key: "item",
              fn: function ({ item }) {
                return [
                  _c(
                    "div",
                    { staticClass: "detail-item-header" },
                    [
                      _c("b-icon", {
                        staticClass: "item-icon success",
                        attrs: { icon: "check-circle-fill" },
                      }),
                      _c("span", { staticClass: "item-name" }, [
                        _vm._v(_vm._s(_vm.getItemName(item))),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "detail-item-subtitle" }, [
                    _vm._v(_vm._s(_vm.getItemReason(item))),
                  ]),
                ]
              },
            },
          ]),
        }),
        _c("CopyCategoryCollapse", {
          attrs: {
            variant: "substituted",
            "header-text": _vm.getSubstitutedHeaderText(),
            items: _vm.substitutedItems,
            show: _vm.showSubstituted,
          },
          on: { toggle: _vm.toggleSubstituted },
          scopedSlots: _vm._u([
            {
              key: "item",
              fn: function ({ item }) {
                return [
                  _c(
                    "div",
                    { staticClass: "detail-item-header" },
                    [
                      _c("b-icon", {
                        staticClass: "item-icon success",
                        attrs: { icon: "check-circle-fill" },
                      }),
                      _c("span", { staticClass: "item-name" }, [
                        _vm._v(_vm._s(_vm.getItemName(item))),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "detail-item-subtitle" }, [
                    _vm._v(" " + _vm._s(_vm.getItemReason(item)) + " "),
                  ]),
                  item.hasNameVariation
                    ? _c(
                        "div",
                        { staticClass: "detail-item-info" },
                        [
                          _c("b-icon", {
                            staticClass: "item-icon info",
                            attrs: { icon: "info-circle-fill" },
                          }),
                          _c("span", { staticClass: "info-text" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("nomenormalizado")) +
                                ': "' +
                                _vm._s(item.normalizedName) +
                                '" '
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
            },
          ]),
        }),
        _c("CopyCategoryCollapse", {
          attrs: {
            variant: "ignored",
            "header-text": _vm.getIgnoredHeaderText(),
            items: _vm.ignoredItems,
            show: _vm.showIgnored,
          },
          on: { toggle: _vm.toggleIgnored },
          scopedSlots: _vm._u([
            {
              key: "item",
              fn: function ({ item }) {
                return [
                  _c(
                    "div",
                    { staticClass: "detail-item-header" },
                    [
                      _c("b-icon", {
                        staticClass: "item-icon danger",
                        attrs: { icon: "x-circle-fill" },
                      }),
                      _c("span", { staticClass: "item-name" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("copysummarylabel", {
                              label: _vm.getIgnoredItemName(item),
                            })
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "detail-item-subtitle" }, [
                    _vm._v(
                      " " + _vm._s(_vm.getIgnoredItemSubtitle(item)) + " "
                    ),
                  ]),
                ]
              },
            },
          ]),
        }),
        _c("CopyCategoryCollapse", {
          attrs: {
            variant: "deleted",
            "header-text": _vm.getDeletedHeaderText(),
            items: _vm.deletedItems,
            show: _vm.showDeleted,
            tooltip: _vm.$t("copysummarydeletedtooltip"),
          },
          on: { toggle: _vm.toggleDeleted },
          scopedSlots: _vm._u([
            {
              key: "item",
              fn: function ({ item }) {
                return [
                  _c(
                    "div",
                    { staticClass: "detail-item-header" },
                    [
                      _c("b-icon", {
                        staticClass: "item-icon danger",
                        attrs: { icon: "trash-fill" },
                      }),
                      _c("span", { staticClass: "item-name" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("copysummarylabel", {
                              label: _vm.getDeletedItemName(item),
                            })
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "detail-item-subtitle" }, [
                    _vm._v(
                      " " + _vm._s(_vm.getDeletedItemSubtitle(item)) + " "
                    ),
                  ]),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }